import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Header,
  Icon,
  Loader,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import AppForm from './AppForm';

class BookingFormTemplateList extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    loading: PropTypes.bool,
    handleSaveTemplateToggle: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props);
    const state = this.getPropsToState(props);
    this.validationForEdit = {};
    this.validationForCreate = {};
    this.state = {
      dataToBeDelete: {},
      isEditing: false,
      isNew: false,
      showDeleteConfirm: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = this.getPropsToState(nextProps);
    this.setState({
      ...state,
    });
  }
  getPropsToState = (props) => {
    const data = props.data;
    const loading = props.loading;

    return {
      data,
      loading,
    };
  }
  hasSRBAccess = (accessibleIn) => {
    const srbAccess = 'SRB'
    return accessibleIn.includes(srbAccess);
  }

  onSave = (index, e) => {
    e.preventDefault();
    const srbAccess = 'SRB'
    let data = this.state.data[index];
    let accessibleIn = data.accessibleIn || []
    if (accessibleIn.includes(srbAccess)) {
      accessibleIn = accessibleIn.filter(i => i !== srbAccess)
    } else {
      accessibleIn.push(srbAccess)
    }
    const id = encodeURIComponent(data.id);
    data.accessibleIn = accessibleIn
    return this.props.handleSaveTemplateToggle(id, data);
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <AppForm
          ref={(ref) => { this.form = ref; }}
          as="div"
        >
          <Table
            striped
            selectable
            padded
            unstackable
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan={16} textAlign="left">
                <Header style={{ marginTop: '.5em', marginBottom: '.5em' }} as="h3">{t('Booking form visibility')}</Header>

                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell colSpan={4}>{t('Booking Form')}</Table.HeaderCell>
                <Table.HeaderCell colSpan={5} />
                <Table.HeaderCell colSpan={3}>{t('Visibility to buyer')}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                this.state.data.length > 0 ?
                  this.state.data.map((value, index) => (
                    <Table.Row key={index}>
                      <Table.Cell colSpan={4}>
                        {value.name}
                      </Table.Cell>
                      <Table.Cell colSpan={5}/>
                      <Table.Cell colSpan={3}>
                        <Button
                          style={{ marginRight: '1em' }}
                          size='tiny'
                          basic
                          disabled={this.state.loading}
                          className="ui compact icon button"
                          onClick={
                            e => this.onSave(
                              index,
                              e,
                            )
                          }
                        >
                          <Icon name="eye" color={this.hasSRBAccess(value.accessibleIn || []) ? "green" : "grey"} />
                        </Button>
                        {
                          t(this.hasSRBAccess(value.accessibleIn || []) ?
                            'On' : 'Off', { ns: TRANSLATION_FILES.translation })
                        }
                      </Table.Cell>
                    </Table.Row>
                  ))
                :
                  <Table.Row>
                    <Table.Cell colSpan={16} textAlign="center">
                      {
                        this.state.loading ?
                          <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        : `${t('No print form found')}.`
                      }
                    </Table.Cell>
                  </Table.Row>
              }
            </Table.Body>
          </Table>
        </AppForm>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(BookingFormTemplateList);



// WEBPACK FOOTER //
// ./src/components/BookingFormTemplateList.jsx